import React from 'react';
import './style.css'; // We'll create this next

function Footer() {
	const currentYear = new Date().getFullYear(); // Get the current year dynamically

	return (
		<footer className="footer-container">
			<div className="footer-content">
				<p>&copy; {currentYear} Rant Hub. All rights reserved.</p>
				<p>Powered by <a href="https://www.themoviedb.org/" target="_blank" rel="noopener noreferrer">TMDb</a> and <a href="https://www.igdb.com/" target="_blank" rel="noopener noreferrer">IGDB</a></p>
				<p>Owned and Run by <a href="https://moonfacetechs.com" target="_blank" rel="noopener noreferrer">Moonface Techs</a></p>
				{/* You can add more links here, e.g., Privacy Policy, Contact */}
				{/* <ul className="footer-links">
					<li><a href="/privacy">Privacy Policy</a></li>
					<li><a href="/contact">Contact Us</a></li>
				</ul> */}
			</div>
		</footer>
	);
}

export default Footer;